import React from 'react';
import Card from '../ui/Card';
import { DashboardFilters } from '../../pages/Dashboard';
const baseRegions = [{
  name: 'Karachi',
  merchants: 1850,
  transactions: 35200,
  baseValue: 5.2,
  share: 41
}, {
  name: 'Lahore',
  merchants: 1240,
  transactions: 24100,
  baseValue: 3.8,
  share: 28
}, {
  name: 'Islamabad',
  merchants: 850,
  transactions: 12500,
  baseValue: 1.9,
  share: 15
}, {
  name: 'Rawalpindi',
  merchants: 420,
  transactions: 6200,
  baseValue: 0.8,
  share: 7
}, {
  name: 'Faisalabad',
  merchants: 280,
  transactions: 4100,
  baseValue: 0.5,
  share: 5
}, {
  name: 'Peshawar',
  merchants: 150,
  transactions: 2100,
  baseValue: 0.2,
  share: 2
}, {
  name: 'Multan',
  merchants: 70,
  transactions: 950,
  baseValue: 0.1,
  share: 1
}, {
  name: 'Quetta',
  merchants: 30,
  transactions: 282,
  baseValue: 0.07,
  share: 1
}];
const timeMultipliers = {
  Today: 1,
  Week: 7,
  MTD: 22,
  YTD: 265
};
const schemeMultipliers: Record<string, number> = {
  'All Schemes': 1,
  Visa: 0.35,
  MasterCard: 0.28,
  PayPak: 0.2,
  UnionPay: 0.1,
  RAAST: 0.07
};
const channelMultipliers: Record<string, number> = {
  'All Channels': 1,
  POS: 0.45,
  'E-commerce': 0.35,
  'RAAST QR': 0.2
};
interface RegionalPerformanceProps {
  filters: DashboardFilters;
}
export const RegionalPerformance: React.FC<RegionalPerformanceProps> = ({
  filters
}) => {
  const {
    timeRange,
    scheme,
    channel
  } = filters;
  const timeMult = timeMultipliers[timeRange];
  const schemeMult = schemeMultipliers[scheme];
  const channelMult = channelMultipliers[channel];
  const totalMult = timeMult * schemeMult * channelMult;
  const regions = baseRegions.map(r => {
    const transactions = Math.round(r.transactions * totalMult);
    const value = r.baseValue * totalMult;
    return {
      name: r.name,
      merchants: r.merchants.toLocaleString(),
      transactions: transactions.toLocaleString(),
      value: value >= 1 ? `PKR ${value.toFixed(1)}B` : `PKR ${(value * 1000).toFixed(0)}M`,
      share: r.share
    };
  });
  return <Card title="Regional Performance" data-id="element-201">
      <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm" data-id="element-202">
        <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700" data-id="element-203">
          <thead className="bg-slate-50 dark:bg-slate-800/80" data-id="element-204">
            <tr data-id="element-205">
              <th scope="col" className="px-5 py-4 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-206">
                Region / City
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-207">
                Active Merchants
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-208">
                Transactions
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-209">
                Value (PKR)
              </th>
              <th scope="col" className="px-5 py-4 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider w-40" data-id="element-210">
                Share
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-slate-800 divide-y divide-slate-100 dark:divide-slate-700/50" data-id="element-211">
            {regions.map(region => <tr key={region.name} className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors" data-id="element-212">
                <td className="px-5 py-4 whitespace-nowrap text-sm font-bold text-slate-900 dark:text-white" data-id="element-213">
                  {region.name}
                </td>
                <td className="px-5 py-4 whitespace-nowrap text-sm font-medium text-slate-600 dark:text-slate-400 text-right" data-id="element-214">
                  {region.merchants}
                </td>
                <td className="px-5 py-4 whitespace-nowrap text-sm font-medium text-slate-600 dark:text-slate-400 text-right" data-id="element-215">
                  {region.transactions}
                </td>
                <td className="px-5 py-4 whitespace-nowrap text-sm font-bold text-slate-900 dark:text-white text-right" data-id="element-216">
                  {region.value}
                </td>
                <td className="px-5 py-4 whitespace-nowrap" data-id="element-217">
                  <div className="flex items-center" data-id="element-218">
                    <span className="text-xs font-bold text-slate-600 dark:text-slate-300 w-10" data-id="element-219">
                      {region.share}%
                    </span>
                    <div className="w-full bg-slate-100 dark:bg-slate-700 rounded-full h-2 ml-3 shadow-inner" data-id="element-220">
                      <div className="bg-gradient-to-r from-accent-500 to-violet-500 h-2 rounded-full shadow-sm" style={{
                    width: `${region.share}%`
                  }} data-id="element-221" />
                    </div>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
};